import { render, staticRenderFns } from "./BlogCardCollection.vue?vue&type=template&id=6024f994&scoped=true"
import script from "./BlogCardCollection.vue?vue&type=script&lang=js"
export * from "./BlogCardCollection.vue?vue&type=script&lang=js"
import style0 from "./BlogCardCollection.vue?vue&type=style&index=0&id=6024f994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024f994",
  null
  
)

export default component.exports